import React, { useState } from "react";


const TabButton = ({ label, pageKey, selectedPage, setSelectedPage, selectedImage, unselectedImage }) => {
    const isSelected = selectedPage === pageKey;

    return (
        <div
            className={`flex items-center mx-3 pl-3 py-1 rounded-lg cursor-pointer transition-colors duration-300 
        ${isSelected ? "bg-black" : "bg-white"}`}
            onClick={() => setSelectedPage(pageKey)}
        >
            <div
                className={`w-[24px] h-[24px]cursor-pointer transition-transform duration-200 ${isSelected ? "scale-105" : "opacity-80"
                    }`}

            >
                <img
                    src={isSelected ? selectedImage : unselectedImage}
                    alt="toggle"
                    className="w-full h-auto rounded-lg"
                />
            </div>

            <span className={`text-[16px] pl-3 font-medium ${isSelected ? "text-white" : "text-black"}`}>
                {label}
            </span>
        </div>
    );
};

export default TabButton;


